import config from '../config'
import { authHeader } from './auth-header'

export const ledgerService = {
  getLedgerTransactions,
  getDailyReport,
  getNotificationReport,
  getInvoiceReport,
  getRefundReport,
  getUpcomingNotifications,
  searchFlightsByDateRange,
  getLedgerInvoices,
}


function getLedgerTransactions () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/ledger/transactions`, requestOptions).then(handleResponse)
}

function getDailyReport (date) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/ledger/dailyReport/${date}`, requestOptions).then(handleResponse)
}

function getNotificationReport () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/notificationReport/`, requestOptions).then(handleResponse)
}

function getUpcomingNotifications () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/notifications/upcoming`, requestOptions).then(handleResponse)
}

function searchFlightsByDateRange (startDate, endDate) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/flights/search/${startDate}/${endDate}`, requestOptions).then(handleResponse)
}

function getLedgerInvoices (startDate, endDate, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  let url = `${config.apiUrl}/ledger/invoices`
  const params = []
  if (startDate) params.push(`startDate=${startDate}`)
  if (endDate) params.push(`endDate=${endDate}`)
  if (search) params.push(`search=${encodeURIComponent(search)}`)
  if (params.length > 0) url += '?' + params.join('&')
  return fetch(url, requestOptions).then(handleResponse)
}

function getInvoiceReport () {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/invoices/invoiceReport/`, requestOptions).then(handleResponse)
}

function getRefundReport () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/invoices/refundReport/`, requestOptions).then(handleResponse)
}


function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout()
        // location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
